import React from 'react';
import moment from 'jalali-moment';
import Content from '../dashboard/Content';
import alarmService from '../../services/alarm-service';
import { Link } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { ucfirst } from '../../utils/easy';


export interface RouteParams {
  sensorId: string;
}

export interface Props extends RouteComponentProps<RouteParams> {
}

export default class AlertListPage extends React.Component<Props> {

  state = {
    alarms: []
  }

  render() {
    const { sensorId } = this.props.match.params;
    const alarms = this.state.alarms.filter(a => a.type === 'LOG_RANGE');
    return (
      <Content title={'خطاهای سنسور ' + sensorId}>
        {(alarms.length === 0) ?
          (
            <div className="col-xxl-5 col-lg-6 col-md-8 col-12 mx-auto text-center">
              <div className="alert alert-success">هشداری برای نمایش وجود ندارد.</div>
            </div>
          ) :
          (
            <ul id="alert-lists-page" className="row">
              {alarms.map(alarm => (
                <li key={alarm._id} className="col-xxl-3 col-lg-4 col-md-6 col-12">
                  {this.renderAlarm(alarm)}
                </li>
              ))}
            </ul>
          )}
      </Content>
    );
  }

  componentDidMount = async () => {
    const { sensorId } = this.props.match.params;
    const alarms = await alarmService.fetchBySensorId(sensorId);
    // const alarms = await this.service.fetchAll();
    this.setState({ alarms });
  }

  renderAlarm = (alarm: any) => {
    const isMax = alarm.meta.alarm === 'max';
    const color = isMax ? '#dc3545' : '#2F9AF1';
    const sensorIcon = isMax ? 'fa-sensor-fire' : 'fa-sensor-alert';
    const dateTime = moment.from(alarm.dateTime, 'en');
    const year = dateTime.format('jYYYY');
    const month = dateTime.format('jM');
    const day = dateTime.format('jD');

    let alarmType = alarm.meta.alarmPhone;
    if (alarmType) {
      alarmType = ucfirst(alarmType) + ' Phone'
    }
    else {
      alarmType = ucfirst(alarm.meta.alarm);
    }

    return (
      <>
        <div className="alert-item">
          <div className="row">
            <div className="col-12 alert-item-header">
              <span>{dateTime.format('jYYYY/jMM/jDD HH:mm:ss')}</span>
              <span className="ml-auto">
                <i className={'fad ' + sensorIcon} style={{ color }}></i>
              </span>
            </div>
          </div>
          <div className="row"><hr /></div>
          <div className="row">
            <div className="col-12 alert-item-body">
              <div className="row">
                <div className="col-12 body-content-container">
                  <span>میانگین دما در بازه هشدار: </span>
                  <span className="code">{alarm.meta.onlineTemp}</span>
                </div>
                <div className="col-12 body-content-container">
                  <span>دمای زمان هشدار: </span>
                  <span className="code">{alarm.meta.alarmTemp}</span>
                </div>
                <div className="col-12 body-content-container">
                  <span>هشدار دمایی: </span>
                  <span className="code">{alarmType}</span>
                </div>
                <div className="col-12">
                  <hr />
                  <Link
                    to={`/dashboard/graph/${alarm.sensor._id}?day=${day}&month=${month}&year=${year}`}
                    className="d-flex btn w-100 justify-content-center">
                    نمایش گراف این هشدار
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

}
